module.exports = __webpack_public_path__ + "img/fruits_top@2x.32db0d7c.png";